import { getOliSearchText } from "@/helpers/generalHelper";
import Srcset from "@/components/common/Srcset";
import {useDispatch} from "react-redux";
import { openOliPopup } from "@/redux/actions/oliCategoryAction";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { useState} from "react" ;
import TextWithEllipse from "../common/TextWithEllipses";

const StatsComp = ({ seoData, oliSearch, totalCount, isPsykhe }) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [showFullText, setShowFullText] = useState(false);

  const handlePrompt = () => {
    setShowFullText(!showFullText);
  }
  // Retrieve searchText from sessionStorage
  const searchText = oliSearch ? getOliSearchText() : '';
  if(!oliSearch && !searchText){
      return (
          <>
              <div className="grid-md-12">
                <div className="search-result-count">
                    <h1 className="xx-large-md x-large-sm x-large-xs light">{seoData?.header}</h1>
                    <sub className="x-small-sm x-small-md xx-small-xs">
                        <div className="x-small-sm x-small-md xx-small-xs">
                        <span className="ais-Stats-text">{totalCount}</span>
                        </div>
                    </sub>
                </div>
                </div>
                <div className="small-md x-small-sm x-small-xs seo-plp-data para-with-link mobile-ellipses d-none d-xs-block">
                <TextWithEllipse text={seoData?.intro} />
                </div>
                <div
                className="small-md x-small-sm x-small-xs seo-plp-data para-with-link d-xs-none"
                dangerouslySetInnerHTML={{ __html: seoData?.intro }}
                ></div>
          </>
      )
  } 

  else if(oliSearch && searchText){
    return (
      <>
        <div className="grid-md-12">
          <div className="oli-plp-data">
            {/* Icon on the Left */}
            <span className="oli-icon" aria-hidden="true">
            <Srcset
              requirePath={true}
              svgFile={true}
              src={"images/Icons/Oli_Icon/Oli_icon.svg"}
              alt="Oli Icon"
              height="47"
              width="43"
            />
            </span>
            {/* Header */}
            <div className="text_wrapper">
              <h1 className="xx-large-md x-large-sm x-large-xs oli-plp-header">Your perfect picks await.</h1>
              <div className="normal-md normal-sm normal-xs light oli-desc-text">
                <div className="promptData">
                  <em>Your results for: </em>
                  <span className={`searchPrompt ${!showFullText ? "ellipse" : ""}`}>
                    {isMobile && searchText.length >=72 ? showFullText ? searchText : searchText.substring(0, 72) : searchText}
                  </span>
                  {/* Show "...more" only on mobile and if text >=72 char */}
                  {isMobile && searchText.length >=72 && (<span className="text_more" onClick={handlePrompt}><span className="hover xx-small">{showFullText? "" : "...more"}</span></span>)}
                </div>
                I think you'll love these, but if you want to refine your search, just ask—I'm here to help. <a tabIndex={0} onClick={() => dispatch(openOliPopup())} className="oli-link bold ga-oli-search-again-button">Search again</a>
              </div>
            </div>
          </div>         
        </div>
      </>
    )
  }
  };

  export default StatsComp;